import builder from '../builder';
import CreditCard1Alternate from '../../streamline-icons/bold/credit-card-1-alternate.svg';

export default builder('IconCreditCard1AlternateBold', CreditCard1Alternate);
